exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-book-menu {\n  display: flex;\n}\n.vue-book-menu__filler {\n    flex: 1 0;\n}\n", ""]);

// exports
